<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="导出明细"
      :innerHeight="100"
      width="300px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <div style="padding: 30px;">
        <el-checkbox v-model="checked" :disabled="imgDisabled">是否带图</el-checkbox>
        <!-- <div style="color: #E63946; margin-top: 15px;">
          有图片最多导出200条，无图片不限制
        </div> -->
      </div>
    </q-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'form', 'imgDisabled', 'columnData'],
  data() {
    return {
      dialogVisible: false,
      checked: false
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
    console.log('123');
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.onExport();
      this.updateVal();
    },
    // 导出 --新接口
    onExport() {
      let _this = this
      let columnList = []
      this.columnData.forEach(v=>{
        columnList.push({
          columnName: v.label,
          fieldName: v.prop
        })
      })
      const loading = this.$loading({
        lock: true,
        text: '数据正在导出中',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });
      let params = {
        exportTag: this.checked,
        pageSize: this.checked ? 200 : 100000,
        pageNum: 1,
        filterData: {
          ...this.form,
          exportColumnList: !this.checked ? columnList.filter(v=>v.columnName != '图片') :  columnList
        }
      };
      this.$q.goodsAnalysis.productAnalyzeExcel({data:params})
      .then((res) => {
        if(res.message) {
          console.log(5555);
          var timer = setInterval(function() {
              _this.$q.goodsAnalysis
                .filePath({fragment: [res.message]})
                .then(res => {
                  if (res.message) {
                    loading.close();
                    clearInterval(timer);
                    _this.downLoad(res.message, `产品概览明细${moment().format('YYYYMMDDHHmmss')}.xlsx`);
                  }
                })
                .catch(err => {
                  //this.$message(err.message)
                });
            }, 3000);
        }else{
          this.$message.fail(res.message);
        }
      });
    },
    downLoad(url, name) {
      this.downLoadLink(url, name);
    },
    downLoadLink(filePath,fileName) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", filePath, true);
      xhr.responseType = "blob";
      xhr.onload = function() {
        if (xhr.status === 200) {
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(xhr.response, fileName);
          } else {
            var link = document.createElement("a");
            var body = document.querySelector("body");

            link.href = window.URL.createObjectURL(xhr.response);
            link.download = fileName;

            // fix Firefox
            link.style.display = "none";
            body.appendChild(link);

            link.click();
            body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          }
        }
      };
      xhr.send();
    }
  }
}
</script>

<style>

</style>